<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>工作汇报</el-breadcrumb-item>
    <el-breadcrumb-item>KPI查看</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>


    <el-row>
  <el-col :span="4"><div class="grid-content bg-purple-dark"><el-input v-model="searDate"  @keyup.enter.native="TitleList" placeholder="授课老师"></el-input></div></el-col>
  <el-col :span="8">
          <div class="block">
    <el-date-picker
      v-model="value2"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptionss">
    </el-date-picker>
  </div>
        </el-col>
    <el-col :span="2"><div class="grid-content bg-purple"> <el-button type="primary" @click="TitleList">查询</el-button></div></el-col>
    <el-col :span="1"><div class="grid-content bg-purple"> <el-button v-if="false" type="primary" :disabled="kpiList.length>0?false:true" @click="outData">导出</el-button></div></el-col>
   <el-col :span="3"> <p class="lableforSearch">查询到{{kpiList.length}}条数据</p></el-col>

</el-row>





    <el-table
    :data="kpiList"
    @selection-change="handleSelectionChange"
    ref="multipleTable"
    border
    style="width: 100%">
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      prop="teacher"
      label="授课老师"
      show-overflow-tooltip
      width="100">
    </el-table-column>
    <el-table-column
      prop="sub_date"
      show-overflow-tooltip
      label="提交时间"
      width="130">
    </el-table-column>

    <el-table-column
      width="180"
      prop="teacherUnit"
      label="所在部门">
    </el-table-column>
    <el-table-column
      label="操作" 
      width="220">
      <template slot-scope="scope">
<el-button   @click="catKpi(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-chakan2"></use></svg></el-button>
<el-button    @click="deleteKpiById(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
</template>
    </el-table-column>
  </el-table>
  </el-card>
  <el-dialog
  :visible.sync="dialogVisible"
  width="90%"
 >
<ComponentsSupervise :formInline="formInline" :fileList="fileList"></ComponentsSupervise>
<el-button type=" primary" @click="dialogVisible=false">取消</el-button>
</el-dialog>
  </div>
</template>

<script>
  import ComponentsSupervise from '@/components/work/teacher/KpiDemo.vue'
export default {
    components:{ComponentsSupervise},
    created(){
        this.getKpi()
    },
    data(){
      return{
        pickerOptionss: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        kpiId:'',
        value2:'',
        searTitleList:'',
        multipleSelection: [],
        searDate:'',
        kpiList:[],
        formInline:{},
        dialogVisible:false,
        fileList:[],
      }
    },methods:{
        getKpi(){
            this.axios.post("/kpi/getKpiByTeacherId")
         .then(resp => { 
                       if(resp.data.status == 1) {
                            this.kpiList=resp.data.result
                            console.log(this.kpiList)
                                }else {
                               
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
        },getFile(){
          this.axios.post("/file/getFile?useId="+ this.kpiId)
         .then(resp => { 
          console.log(resp)
                       if(resp.data.status == 1) {
                        this.fileList=resp.data.result
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
        },deleteKpiById(data){
          const that=this
        this.$confirm("确定删除？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){  
        that.axios.post("/kpi/deleteKpiById?kpi_id="+ data.kpi_id)
         .then(resp => { 
          console.log(resp)
                       if(resp.data.status == 1) {
                        that.$message.success("删除成功")
                        that.getKpi()
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
      })
        },
        catKpi(data){
          this.kpiId=data.kpi_id
          this.getFile()
      this.dialogVisible=true
      console.log(data)
      this.formInline=data
        },TitleList(){
    const starDate=this.$formateDate.format(this.value2[0], 'yyyy-MM-dd HH:mm:ss')
      const endDate=this.$formateDate.format(this.value2[1], 'yyyy-MM-dd HH:mm:ss')
    if(this.searTitleList.length<=0){
          this.searTitleList=this.kpiList
        }
        this.kpiList=this.searTitleList
        // .includes
        this.kpiList=this.kpiList.filter((item)=>{
         if(this.searDate!=''){
          console.log(item.teacher,this.searDate)
          return item.teacher.includes(this.searDate)
         }else{
          return true
         }     
        })

        
        this.kpiList=this.kpiList.filter((item)=>{
         if(this.value2.length>0){
          return starDate<item.sub_date&&item.sub_date<endDate
         }else{
          return true
         }     
        })

       
  },
  handleSelectionChange(val) {
    console.log( val)
        this.multipleSelection = val;
      },
      outData(){

        this.axios({
        url: "/kpi/outKpi",   //后端地址
        method: "post",
        data:this.multipleSelection, //请求参数
        headers: {  
        'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
        },
        // contenType:'application/json',
        responseType: "blob"
      })
        .then(res => {
          const blob = new Blob([res.data], { type: 'xlsx' });
          const fileName = "KPI数据报表.xlsx"; 
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink); 
            this.selectData=false
        })


        // this.axios.post("/kpi/outKpi",this.multipleSelection)
        //  .then(resp => { 
        //   console.log(resp)
        //                if(resp.data.status == 1) {
        //                 this.fileList=resp.data.result
        //                         }
        //                     })
        //                     .catch((err) => {
        //                         alert("出错了")
        //                         console.log(err)
        //                     }) 
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/teacher/ViewTeacherKpi.vue